import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomPlusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 142,
	height: 142,
	viewBox: "0 0 142 142",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "Ellipse_48",
		x: 0,
		y: 0,
		width: 142,
		height: 142,
		filterUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("feOffset", { input: "SourceAlpha" }),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 5,
				result: "blur"
			}),
			/* @__PURE__ */ _jsx("feFlood", {
				floodColor: "#1c1936",
				floodOpacity: .302
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				operator: "in",
				in2: "blur"
			}),
			/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
		]
	}), /* @__PURE__ */ _jsxs("filter", {
		id: "Path_3405",
		x: 29,
		y: 29,
		width: 83.721,
		height: 83.721,
		filterUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("feOffset", { input: "SourceAlpha" }),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 5,
				result: "blur-2"
			}),
			/* @__PURE__ */ _jsx("feFlood", {
				floodColor: "#1c1936",
				floodOpacity: .302
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				operator: "in",
				in2: "blur-2"
			}),
			/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
		]
	})] }), /* @__PURE__ */ _jsxs("g", {
		id: "play_icon",
		"data-name": "play icon",
		transform: "translate(-835.789 -1690.789)",
		children: [/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1, 0, 0, 1, 835.79, 1690.79)",
			filter: "url(#Ellipse_48)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Ellipse_48-2",
				"data-name": "Ellipse 48",
				transform: "translate(15 15)",
				fill: "none",
				stroke: "#fff",
				strokeWidth: 4,
				children: [/* @__PURE__ */ _jsx("circle", {
					cx: 56,
					cy: 56,
					r: 56,
					stroke: "none"
				}), /* @__PURE__ */ _jsx("circle", {
					cx: 56,
					cy: 56,
					r: 54,
					fill: "none"
				})]
			})
		}), /* @__PURE__ */ _jsx("g", {
			transform: "matrix(1, 0, 0, 1, 835.79, 1690.79)",
			filter: "url(#Path_3405)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_3405-2",
				"data-name": "Path 3405",
				d: "M5-26.634v10.988H26.366V5.721H37.355V-15.645H58.721V-26.634H37.355V-48H26.366v21.366Z",
				transform: "translate(39 92)",
				fill: "#fff"
			})
		})]
	})]
});
export default SvgZoomPlusIcon;
